export default __webpack_public_path__ + "static/media/Highlights_title_normal.19bf070b.svg";